export const league = {
  // 页面头部
  title: "月度排位赛",
  subtitle: "每月系统派 5 个对手，冲段拼分。",
  backHome: "← 首页",

  // 统计卡
  stats: {
    rating: "积分",
    passes: "免战券",
    played: "已打",
    won: "胜",
    refused: "拒绝",
  },

  // 加入引导
  join: {
    title: "加入本月排位赛",
    body1: "Acework 将在本月内为你派 {{count}} 个对手。",
    body2:
      "每个对手必须在 7 天内打完。每月可用 5 张免战券应对时间冲突。失约或不打的比赛会扣积分。",
    button: "加入排位赛",
    joining: "加入中...",
  },

  // 阵容槽
  slot: {
    matchLabel: "第 {{num}} 场",
    unassigned: "等待派对手",
    pending: "对手已派 — 接受或用免战券",
    accepted: "已确认 — 去比赛",
    played: "已完成",
    refused: "已拒绝（用了 1 张免战券）",
    forfeit: "失约（超过时限）",
    bye: "轮空（暂无合适对手）",
    ratingLabel: "积分 {{rating}}",
    deadline: "截止：{{date}}",
    win: "✓ 胜",
    loss: "✗ 负",
    ratingDelta: "（积分 {{delta}}）",
    accept: "接受",
    usePass: "用免战券",
    recordScore: "录入比分",
    confirmRefuse: "确定使用免战券？每月数量有限。",
  },
};

export const rating = {
  label: "Acework 积分",
  overall: "总 Rating",
  entryLabel: "入门 Rating",
  primaryLabel: "进阶 Rating",
  unranked: "未排位",
  matchesShort: "{{count}} 场",
  outOf: "/ 16.50",
  placement: "定位赛 · {{played}}/{{total}}",
  rankedMatches: "积分赛场次",
  tierBeginner: "初学",
  tierRecreational: "休闲",
  tierClub: "俱乐部",
  tierStrongClub: "进阶俱乐部",
  tierAdvanced: "高级",
  tierHighLevel: "高水平",
  tierSemiPro: "准职业",
  tierElite: "精英",
};
